import { __awaiter, __generator } from "tslib";
import { sha1, uuid } from '@ekuaibao/helpers';
import { sourceCustomerUrl } from '@ekuaibao/lib/lib/enums';
import { permissionName } from '../elements/configure/config';
import { Fetch } from '@ekuaibao/fetch';
var getCNmae = function (user) {
    var permissions = user.permissions || [];
    var staff = user.staff || {};
    var admin = !!~permissions.indexOf('SYS_ADMIN') ? i18n.get('管理员') : i18n.get('用户');
    var name = staff.name;
    return encodeURIComponent(name + i18n.get('（app/') + admin + i18n.get('）'));
};
export function getCustomerServiceUrlOfZHICHI(user, sourceId, channelid) {
    var permissions = user.permissions || [];
    var staff = user.staff || {};
    var admin = !!~permissions.indexOf('SYS_ADMIN') ? i18n.get('管理员') : i18n.get('用户');
    var name = staff.name;
    var corp = staff.corporation && staff.corporation.name;
    var c_name = name + i18n.get('（app/') + admin + i18n.get('）');
    var web_token = staff.id;
    var key = 'bf62151d7cce4b1f881c8bf898bab775';
    var nonce = uuid(32);
    var timestamp = +new Date();
    var signature = "nonce=" + nonce + "&timestamp=" + timestamp + "&web_token=" + web_token + "&" + key;
    signature = sha1(signature);
    signature = signature.toUpperCase();
    var customerUrl = sourceCustomerUrl[window.__PLANTFORM__];
    if (channelid !== undefined) {
        var strs = customerUrl.split('&');
        var strList_1 = [];
        strs.forEach(function (str) {
            if (str.includes('channelid=')) {
                str = "channelid=" + channelid;
            }
            strList_1.push(str);
        });
        customerUrl = strList_1.join('&');
    }
    var corpId = staff.corporation && staff.corporation.id;
    var cellphone = staff.cellphone;
    var permissionNames = permissions
        .map(function (item) { return permissionName(item); })
        .filter(function (item) { return item; })
        .join(',');
    return (customerUrl +
        '&web_plugin_id=' +
        sourceId +
        '&nonce=' +
        nonce +
        '&timestamp=' +
        timestamp +
        '&signature=' +
        signature +
        '&web_token=' +
        web_token +
        '&c_name=' +
        encodeURIComponent(c_name) +
        '&c_org=' +
        encodeURIComponent(corp) +
        '&partnerid=' +
        web_token +
        '&uname=' +
        encodeURIComponent(name) +
        '&realname=' +
        encodeURIComponent(corp) +
        '&tel=' +
        cellphone +
        '&customer_fields=' +
        encodeURIComponent(JSON.stringify({
            customField4: permissionNames,
            customField6: corp,
            customField8: corpId
        })));
}
export function getAskBotCustomerServiceUrl(user) {
    var staff = user.staff || {};
    var userName = staff.name;
    var userId = staff.id;
    var companyName = staff.corporation && staff.corporation.name;
    var source = window.__PLANTFORM__;
    var timestamp = +new Date();
    var appId = 5001;
    var id = 199;
    var apiKey = '9c5b9583655d42afab6a0037c09fa994';
    var secretKey = '4e5463784e546b774d4449334e7a51314d54677a';
    return ('https://ekuaibao-mall.guoranbot.com/?appId=' +
        appId +
        '&userId=' +
        userId +
        '&userName=' +
        encodeURIComponent(userName) +
        '&companyName=' +
        encodeURIComponent(companyName) +
        '&source=' +
        source +
        '&timestamp=' +
        timestamp +
        '&apiKey=' +
        apiKey +
        '&id=' +
        id +
        '&secretKey=' +
        secretKey);
}
export var getServiceUrl = function (ops) { return __awaiter(void 0, void 0, Promise, function () {
    return __generator(this, function (_a) {
        return [2, Fetch.GET('/api/message/v1/online/customer', ops)];
    });
}); };
var PLATFORM_CHANNELID_MAP = {
    DEBUGGER: '2',
    DING_TALK: '3',
    KD_CLOUD: '8',
    WEIXIN: '4',
    APP: '2',
    HUAWEI: '9',
    THIRDPARTY: '2',
    FEISHU: '5',
    UNIAPP: '2',
    HYBRID: '2'
};
export var getCustomerServiceUrl = function (user, sourceId, channelid) { return __awaiter(void 0, void 0, void 0, function () {
    var res, _a;
    var _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                return [4, getServiceUrl({
                        type: 1,
                        channelId: channelid || PLATFORM_CHANNELID_MAP[window.__PLANTFORM__],
                        webPluginId: sourceId,
                        cName: getCNmae(user),
                    })];
            case 1:
                res = _c.sent();
                return [2, (_b = res === null || res === void 0 ? void 0 : res.value) === null || _b === void 0 ? void 0 : _b.url];
            case 2:
                _a = _c.sent();
                return [2, getCustomerServiceUrlOfZHICHI(user, sourceId, channelid)];
            case 3: return [2];
        }
    });
}); };
export default getCustomerServiceUrl;
